import './rxjs-extension';
import { NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// modules
import { PaginationModule, TabsModule } from 'ng2-bootstrap';
//components
import { APPROUTES } from './app.routes';
import { reportingRoutes } from './app.reporting-routes';

import { AppComponent } from './app.component';
import { 
  LegalEntitiesReportService,ENFTReportService,
  OnGoingReportService,NewHireFullTimeService, ErCoverageReportService,
  EmployeeEligibilityReportService,
  EmployeeDemographicReportService,
  EmployeeBreakInServiceReportService,
  PayrollDataActivityReportService,
  EmployeeSummaryReportService,
  ControlGroupService,
  ApplicableLargeEmployeeService,
  ApplicableLargeEmployeeDetailsService,InsuranceInfoReportService,
  AcaDataReportService,
  Original1095cService,
} from './index';
import { SideNavComponent } from './layout/sidenav.component';
import { TopNavComponent } from './layout/topnav.component';

// services

import { ExportToExcelService } from './shared/index';
import { ClientOnboardingCustomerInfoService } from './OnBoardingCustomerInformation/index';
import { LoginService } from './login/index';
import { FilemanagerService } from './filemanager/index';
import { UsermanagementService } from './usermanagement/index';
import { FilesummaryService } from './filesummary/filesummary.service';
import { FileerrorsService } from './fileerrors/fileerrors.service';
import { AuthGuard } from './login/auth-guard.service';
import { SharedService } from './app.shared.service';
import { AlertService } from './alert/index';
import { employeeStabilityPeriodReportService } from './employeeStabilityPeriodReport/employeeStabilityPeriodReport.service';
import { ShownamesService } from './shownames/shownames.service';
import { PayhistoryService } from './payhistory/payhistory.service';
import { SickLeaveService } from './sick leave Report/sick.service'
import { TerminationReportService } from './terminationreport/terminationreport.service';
import { BenefitsenrollmentstatusComponentService } from './benefitsenrollmentstatus/benefitsenrollmentstatus.service';
import { CostAnalysisVendorService } from './costanalysisvendor/costanalysisvendor.service';
import { CostAnalysisShowService } from './costanalysisshow/costanalysisshow.service';
import { CostAnalysisAccountService } from './costanalysisaccount/costanalysisaccount.service';
import { CostAnalysisIrs1099Service } from './costanalysisirs1099/costanalysisirs1099.service';
import { CostAnalysisPayrollService } from './costanalysispayroll/costanalysispayroll.service';
import { CostAnalysisIrs1099DetailService } from './costanalysisirs1099Detail/costanalysisirs1099Detail.service';
import { CostanalysisdocumentService } from './costanalysisdocumentnumber/costanalysisdocument.service';
import { CostAnalysisPayrollDetailService } from './costanalysispayrolldetail/costanalysispayrolldetail.service';
import { CostanalysisVendorDetailService } from './costanalysisvendordetail/costanalysisvendordetail.service';
import { CostanalysisDocumentDetailService } from './costanalysisdocumentnumberdetail/costanalysisdocumentnumberdetail.service';
import { CostanalysisshowDetailbyShownameService } from './costanalysisshowdetailbyshow/costanalysisshowdetailbyshow.service';
import { ShowCostByAccountService } from './costanalysisshowdetailbyaccount/costanalysisshowdetailbyaccount.service';
import { CostanalysisVendorDetailAllService } from './costanalysisvendordetailsbyall/costanalysisvendordetailsbyall.service';
import { CostanalysisAccountDetailService } from './costanalysisaccountdetail/costanalysisaccountdetail.service';
import { InvoiceReportService } from './invoicereport/invoicereport.service';
import { EmployeeNewHireService } from './employeenewhirereport/employeenewhirereport.service';
import { EmployeedetailsService } from './employeedetails/employeedetails.service';
import { EpcaresService } from './epcares/epcares.service';
import { MonthleypaidService } from './monthlypaidemployees/monthleypaid.service';
import { AuditreportService } from './auditreport/auditreport.service';
import { IrsauditService } from './irsaudittable/irsaudit.service';
import { AuthService } from './auth.service';
import { ForgotpasswordService } from './forgotpassword/forgotpassword.service';
import { SetpasswordService } from './setpassword/setpassword.component.service';
import { ResetpasswordService } from './resetpassword/resetpassword.service';
import { Report401kService } from './report401k/report401k.service';
import { SharedModule } from './sharedModules/shared.module';
import { AppLayoutComponent } from './layout/layout.component';
import { orientationPeriodService } from './orientationperiod/orientationperiod.service';
import { verificationemployeedataService } from './verificationofemployeedata/verificationofemployeedata.service';
import { employeeStatusService } from './employment-status-report/employment-status-report.service';
import { DatasheetService } from './datasheet-tracker/datasheet.service';
import { DashboardService } from './dashboard/dashboard.service';
import { FilesUploadService } from './fileupload/fileupload.service';
import { FederalPayDayService } from './federal-pay-day/federal-pay-day.service';
import { StatePayDayService } from './state-pay-day/state-pay-day.service';
import { AnnualAverageService } from './annual-average/annual-average.service';
import { InviteUserService } from './inviteuser/inviteuser.service';
import { CalsaversemployersizeService } from './calsaversemployersize/calsaversemployersize.service';
import { CalsaversService } from './calsaver/calsaver.service';
import { NewclientsService } from './newclients/newclients.service';
import { SharpNewHireService } from './sharp-new-hire-report/sharp-new-hire-report.service';
import { CurrentlyEmployedService } from './currently-employed/currently-employed.service';
import { DynamicReportService } from './dynamic-report/dynamic-report.service';
import { GranularLevelService } from './granular-level/granular-level.service';
import { NotificationService } from './notifications/notifications.service';
import { DeiService } from './dei/dei.service';
import { Report401kpaymentService } from './401kpayments/Report401kpayment.service';
import { DetailpayrolleditService } from './detailpayrolledit/detailpayrolledit.service';
import { bmpService } from './bmp/bmp.service';
import { employeeearningsummaryreportService } from './employeeearningsummaryreport/employeeearningsummaryreport.service';
import { CustomaggegatefringeService } from './customaggegatefringe/customaggegatefringe.service';
import { DataserviceService } from './customaggegatefringe/dataservice.service';

@NgModule({
  imports: [
    RouterModule.forRoot(APPROUTES, { useHash: true }),
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    BrowserAnimationsModule,// required animations module
    reportingRoutes,
    SharedModule
  ],
  declarations: [
    AppComponent,
    SideNavComponent,
    TopNavComponent,
    AppLayoutComponent,
  ],
  providers: [
    DashboardService,
    DatasheetService,
    verificationemployeedataService,
    orientationPeriodService,
    ENFTReportService,
    OnGoingReportService,
    ExportToExcelService,
    NewHireFullTimeService,
    ErCoverageReportService,
    EmployeeEligibilityReportService,
    EmployeeDemographicReportService,
    EmployeeBreakInServiceReportService,
    PayrollDataActivityReportService,
    EmployeeSummaryReportService,
    ControlGroupService,
    ApplicableLargeEmployeeService,
    ApplicableLargeEmployeeDetailsService,
    employeeStabilityPeriodReportService,
    ClientOnboardingCustomerInfoService,
    LegalEntitiesReportService,
    InsuranceInfoReportService,
    AcaDataReportService,
    Original1095cService,
    LoginService,
    FilemanagerService,
    UsermanagementService,
    AuthGuard,
    FilesummaryService,
    FileerrorsService,
    SharedService,
    AlertService,
    ShownamesService,
    PayhistoryService,
    SickLeaveService,
    TerminationReportService,
    BenefitsenrollmentstatusComponentService,
    CostAnalysisVendorService,
    CostAnalysisShowService,
    CostAnalysisAccountService,
    CostAnalysisIrs1099Service,
    CostAnalysisPayrollService,
    CostAnalysisIrs1099DetailService,
    CostanalysisdocumentService,
    CostAnalysisPayrollDetailService,
    CostanalysisVendorDetailService,
    CostanalysisDocumentDetailService,
    CostanalysisshowDetailbyShownameService,
    ShowCostByAccountService,
    CostanalysisVendorDetailAllService,
    CostanalysisAccountDetailService,
    InvoiceReportService,
    EmployeeNewHireService,
    EmployeedetailsService,
    IrsauditService,
    AuthService,
    ForgotpasswordService,
    ResetpasswordService,
    SetpasswordService,
    EpcaresService,
    AuditreportService,
    MonthleypaidService,
    Report401kService,
    employeeStatusService,
    FilesUploadService,
    FederalPayDayService,
    StatePayDayService,
    AnnualAverageService,
    InviteUserService,
    CalsaversemployersizeService,
    NewclientsService,
    SharpNewHireService,
    CurrentlyEmployedService,
    DynamicReportService,
    GranularLevelService,
    NotificationService,
    DeiService,
    Report401kpaymentService,
    DetailpayrolleditService,
    CalsaversService,
    bmpService,
    employeeearningsummaryreportService,
    CustomaggegatefringeService,
    DataserviceService,
  ],
  
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts